import { call, put, takeLatest } from "redux-saga/effects"
import {
  FETCH_COMPANY_DETAILS,
  UPDATE_COMPANY_DETAILS,
  CREATE_COMPANY_DETAILS,
} from "./actionTypes"
import {
  fetchCompanyDetailsSuccess,
  fetchCompanyDetailsFail,
  updateCompanyDetailsSuccess,
  updateCompanyDetailsFail,
  createCompanyDetailsSuccess,
  createCompanyDetailsFail,
} from "./actions"
import { getCompanyDetails, patchCompanyDetails, postCompanyDetails } from "helpers/api_helper"

function* fetchCompanyDetailsSaga() {
  try {
    const companyDetails = yield call(getCompanyDetails)
    yield put(fetchCompanyDetailsSuccess(companyDetails))
  } catch (error) {
    yield put(fetchCompanyDetailsFail(error.message))
  }
}

function* updateCompanyDetailsSaga(action) {
  try {
    const data = action.payload
    const payload = {
      resource: [data],
    }
    const result = yield call(patchCompanyDetails, payload)
    if (result && result.resource && result.resource[0]) {
      yield put(updateCompanyDetailsSuccess(data))
    } else {
      yield put(updateCompanyDetailsFail("Failed to update company details"))
    }
  } catch (error) {
    yield put(updateCompanyDetailsFail(error.message))
  }
}

function* createCompanyDetailsSaga(action) {
  try {
    const data = action.payload
    const payload = {
      resource: [data],
    }
    const result = yield call(postCompanyDetails, payload)
    if (result && result.resource && result.resource[0]) {
      const createdData = { ...data, id: result.resource[0].id }
      yield put(createCompanyDetailsSuccess(createdData))
    } else {
      yield put(createCompanyDetailsFail("Failed to create company details"))
    }
  } catch (error) {
    yield put(createCompanyDetailsFail(error.message))
  }
}

function* companySaga() {
  yield takeLatest(FETCH_COMPANY_DETAILS, fetchCompanyDetailsSaga)
  yield takeLatest(UPDATE_COMPANY_DETAILS, updateCompanyDetailsSaga)
  yield takeLatest(CREATE_COMPANY_DETAILS, createCompanyDetailsSaga)
}

export default companySaga
